import React from 'react';
import PropTypes from 'prop-types';
import MoneyFlowDetail from './MoneyFlowDetail';

const MoneyFlowDetails = ({ collection }) => {
  const resource = collection?.resources()?.head();

  if (!resource) {
    return null;
  }

  return (
    <MoneyFlowDetail
      resource={resource}
    />
  );
};

MoneyFlowDetails.propTypes = {
  collection: PropTypes.object.isRequired,
};

MoneyFlowDetails.defaultProps = {};

export default MoneyFlowDetails;
